/* RR - navigation horizontale des selecteurs de variantes */
(function () {
  if (window.__rrVpInit) return;
  window.__rrVpInit = true;

  var SCROLL = '.rr-vp__scroll';

  function sync(sc) {
    var wrap = sc.parentElement;
    if (!wrap || !wrap.classList.contains('rr-vp__wrap')) return;

    var overflow = sc.scrollWidth - sc.clientWidth > 2;
    wrap.classList.toggle('is-scrollable', overflow);
    wrap.classList.toggle('at-start', sc.scrollLeft <= 2);
    wrap.classList.toggle('at-end', sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2);

    if (overflow && !sc.dataset.rrPos) {
      var checked = sc.querySelector('.rr-vp__input:checked');
      var label = checked && checked.nextElementSibling;
      if (label) {
        sc.scrollLeft = Math.max(0, label.offsetLeft - sc.clientWidth / 2 + label.offsetWidth / 2);
      }
      sc.dataset.rrPos = '1';
      wrap.classList.toggle('at-start', sc.scrollLeft <= 2);
      wrap.classList.toggle('at-end', sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2);
    }
  }

  function syncAll() {
    var list = document.querySelectorAll(SCROLL);
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      syncAll();
    }, 60);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.rr-vp__nav') : null;
    if (!btn) return;
    e.preventDefault();
    var sc = btn.parentElement.querySelector(SCROLL);
    if (!sc) return;
    var dir = btn.classList.contains('rr-vp__nav--next') ? 1 : -1;
    sc.scrollBy({ left: dir * Math.max(180, sc.clientWidth * 0.8), behavior:(window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth') });
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(SCROLL)) sync(t);
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.rr-vp')) {
      setTimeout(schedule, 400);
      setTimeout(schedule, 1200);
    }
  });

  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  schedule();
  setTimeout(syncAll, 500);
})();

/* RR - mobile : selecteur de coloris juste sous le carrousel photo */
(function () {
  if (window.__rrColorMirror) return;
  window.__rrColorMirror = true;

  var st = document.createElement('style');
  st.textContent =
    '.rr-vp-mcolor{display:none}' +
    '@media (width <= 750px){' +
    '.rr-vp-mcolor{display:block;margin:0}' +
    '.rr-vp-mcolor .rr-vp__opt{margin:0}' +
    '.product-section__product-info .rr-vp__opt--swatch{display:none}' +
    '}';
  document.head.appendChild(st);

  function source() {
    return document.querySelector('.product-section__product-info .rr-vp__opt--swatch');
  }

  function build() {
    var content = document.querySelector('.product-section__content');
    if (!content) return;
    var medias = content.querySelector(':scope > .product-section__medias');
    var mirror = content.querySelector(':scope > .rr-vp-mcolor');
    var src = source();
    if (!src || !medias) {
      if (mirror) mirror.remove();
      return;
    }

    var inputs = src.querySelectorAll('.rr-vp__input');
    var sig = '';
    for (var i = 0; i < inputs.length; i++) {
      sig +=
        inputs[i].getAttribute('data-option-value-id') +
        (inputs[i].checked ? '*' : '') +
        (inputs[i].getAttribute('aria-disabled') || '') +
        '|';
    }
    var sel = src.querySelector('.rr-vp__sel');
    sig += sel ? sel.textContent : '';
    if (mirror && mirror.getAttribute('data-sig') === sig) return;

    var oldSc = mirror ? mirror.querySelector('.rr-vp__scroll') : null;
    var prevScroll = oldSc ? oldSc.scrollLeft : null;

    var clone = src.cloneNode(true);
    var junk = clone.querySelectorAll('.rr-vp__hint, .rr-vp__head > :not(.rr-vp__name):not(.rr-vp__sel)');
    for (var j = 0; j < junk.length; j++) junk[j].remove();

    var cin = clone.querySelectorAll('.rr-vp__input');
    for (var k = 0; k < cin.length; k++) {
      var oldId = cin[k].id;
      var nid = 'rr-mcolor-' + k;
      var lab = oldId ? clone.querySelector('label[for="' + oldId + '"]') : null;
      cin[k].id = nid;
      cin[k].name = 'rr-mcolor';
      if (lab) lab.setAttribute('for', nid);
    }
    for (var m = 0; m < cin.length; m++) cin[m].checked = !!(inputs[m] && inputs[m].checked);

    var wrap = document.createElement('div');
    wrap.className = 'rr-vp rr-vp-mcolor';
    wrap.setAttribute('data-sig', sig);
    wrap.appendChild(clone);

    if (mirror) {
        var ae = document.activeElement;
        var fid = ae && mirror.contains(ae) ? ae.id : '';
        mirror.replaceWith(wrap);
        if (fid) {
          var nf = wrap.querySelector('[id="' + fid + '"]');
          if (nf) nf.focus({ preventScroll: true });
        }
      }
    else medias.insertAdjacentElement('afterend', wrap);

    var sc = wrap.querySelector('.rr-vp__scroll');
    if (sc && prevScroll !== null) {
      sc.scrollLeft = prevScroll;
      sc.setAttribute('data-rr-pos', '1');
    }
  }

  var t = null;
  function schedule() {
    if (t) clearTimeout(t);
    t = setTimeout(function () {
      t = null;
      build();
    }, 50);
  }

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.closest) return;
    if (inp.closest('.rr-vp-mcolor')) {
      var src = source();
      var orig = src
        ? src.querySelector('.rr-vp__input[data-option-value-id="' + inp.getAttribute('data-option-value-id') + '"]')
        : null;
      if (orig && !orig.checked) orig.click();
      return;
    }
    if (inp.closest('.rr-vp')) {
      schedule();
      setTimeout(schedule, 500);
      setTimeout(schedule, 1500);
    }
  });

  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var n = list[i].target;
      var el = n.nodeType === 1 ? n : n.parentElement;
      if (!el || !el.closest || !el.closest('.rr-vp-mcolor')) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();

/* RR - le rideau du laboratoire (module 2) prend le coloris choisi dans la fiche.
   Coloris connus : notre tissu uni dans ce coloris. Autres : tissu neutre teinté. */
(function () {
  if (window.__rrFabSync) return;
  window.__rrFabSync = true;

  var CDN = 'https://cdn.shopify.com/s/files/1/1092/8114/9260/files/';
  var TISSUS = {
    'beige lin': 'rr-tissu-beige-lin.jpg?v=1790333808',
    'blanc': 'rr-tissu-lin-blanc.jpg?v=1790335749',
    'gris clair': 'rr-tissu-lin-gris-clair.jpg?v=1790335750',
    'gris foncé': 'rr-tissu-lin-gris-fonce.jpg?v=1790335750',
    'café': 'rr-tissu-lin-cafe.jpg?v=1790335750',
    'vert olive': 'rr-tissu-lin-vert-olive-2.jpg?v=1790336387',
    'brun foncé': 'rr-tissu-lin-brun-fonce.jpg?v=1790335750'
  };
  var NEUTRE = 'rr-tissu-lin-neutre.jpg?v=1790335750';
  var cache = {};

  function setFabric(url, blend, col) {
    var r = document.documentElement.style;
    r.setProperty('--rr-fab-img', 'url("' + url + '")');
    r.setProperty('--rr-fab-blend', blend);
    if (col) r.setProperty('--rr-fab-col', col);
  }

  function avgFromImage(url, done) {
    if (cache[url]) return done(cache[url]);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = 24;
        c.height = 24;
        var x = c.getContext('2d');
        x.drawImage(img, 0, 0, 24, 24);
        var d = x.getImageData(0, 0, 24, 24).data, r = 0, g = 0, b = 0, n = d.length / 4;
        for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }
        var k = 1.2, f = function (v) { return Math.min(255, Math.round((v / n) * k)); };
        cache[url] = 'rgb(' + f(r) + ',' + f(g) + ',' + f(b) + ')';
        done(cache[url]);
      } catch (e) {}
    };
    img.src = url;
  }

  function sync() {
    var src = document.querySelector('.product-section__product-info .rr-vp__opt--swatch');
    if (!src) return;
    var inp = src.querySelector('.rr-vp__input:checked');
    if (!inp) return;
    var name = (inp.value || '').trim().toLowerCase();
    if (TISSUS[name]) { setFabric(CDN + TISSUS[name], 'normal'); return; }
    var dot = src.querySelector('label[for="' + inp.id + '"] .rr-vp__dot');
    var bg = dot ? (dot.style.getPropertyValue('--sw') || '').trim() : '';
    var m = bg.match(/url\((['"]?)(.*?)\1\)/);
    if (m) avgFromImage(m[2].replace(/([?&])width=\d+/, '$1width=64'), function (col) { setFabric(CDN + NEUTRE, 'multiply', col); });
    else if (bg) setFabric(CDN + NEUTRE, 'multiply', bg);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.rr-vp')) {
      setTimeout(sync, 50);
      setTimeout(sync, 800);
    }
  });
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  sync();
})();
